import React from 'react';
import './SapConsultingWhyChoose.css';
import SECIMG from '../../assets/images/sec.png'; 

const SapConsultingWhyChoose = () => {
  return (
    <section className="sap-why-choose-section">
      <div className="container">
        <div className="sap-why-choose-grid">
          <div className="sap-why-choose-text">
            <h2 className="sap-why-choose-title">Why Choose Neuroverse AI for SAP Consulting?</h2>
            <p>
              Choosing the right staffing partner can transform your business operations. With Neuroverse AI, you gain:
            </p>
            <ul>
              <li>Access to top staff augmentation services in the UK.</li>
              <li>Customized solutions that prioritize your specific needs.</li>
              <li>A streamlined hiring process designed for efficiency and quality.</li>
              <li>A strategic partner committed to your success.</li>
            </ul>
          </div>
          <div className="sap-why-choose-image-container">
            <img 
              src={SECIMG}
              alt="Why Choose Neuroverse AI" 
              className="sap-why-choose-image"
            />
          </div>
        </div>
        <div className="reasons-grid">
          <div className="reason-card">
            <h4>Experienced Consultants</h4>
            <p>Our team comprises the best SAP consultants for businesses in the USA, offering expertise across diverse industries.</p>
          </div>
          <div className="reason-card">
            <h4>Tailored Solutions</h4>
            <p>We customize our SAP services to align with your business goals and industry requirements.</p>
          </div>
          <div className="reason-card">
            <h4>End-to-End Support</h4>
            <p>We provide a seamless SAP journey for your enterprise from initial planning to implementation and ongoing support.</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SapConsultingWhyChoose;
